var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99986 4.66677V2.34177C9.99986 1.96677 9.54986 1.78344 9.29153 2.05011L6.12486 5.20844C5.95819 5.37511 5.95819 5.63344 6.12486 5.80011L9.28319 8.95844C9.54986 9.21677 9.99986 9.03344 9.99986 8.65844V6.33344C13.1082 6.33344 15.5665 9.18344 14.8832 12.4084C14.4915 14.3001 12.9582 15.8251 11.0749 16.2168C8.09986 16.8418 5.44986 14.8001 5.04986 12.0418C4.99153 11.6418 4.64153 11.3334 4.23319 11.3334C3.73319 11.3334 3.33319 11.7751 3.39986 12.2751C3.91653 15.9334 7.39986 18.6418 11.3415 17.8751C13.9415 17.3668 16.0332 15.2751 16.5415 12.6751C17.3665 8.40011 14.1165 4.66677 9.99986 4.66677Z",
    fill: "#EE3932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.e28af02351875161b02049e3ee3ad3f8.svg";
export { ForwardRef as ReactComponent };